import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import AddTask from './add';
import CopyTask from './copy';
import Task from './task';
import withDragDropContext from 'helpers/react_dnd/with_drag_drop_context';

import './styles.scss';

export function PlaybookTasks({ canRequirePlaybookTasks, playbook, playbooks, stage }) {
  const hasTasks = useMemo(() => {
    return Object.values(playbooks).some((playbook) => {
      return Object.values(playbook.tasksByStage).some(tasks => tasks && tasks.length > 0);
    });
  }, [playbooks]);

  return (
    <div className="playbook-tasks">
      <p>Create the following <b>deal tasks:</b></p>

      <table className="table">
        <thead>
          <tr>
            <th width="0" />
            <th>Name</th>
            {canRequirePlaybookTasks && <th>Required</th>}
            <th>Attachment</th>
            <th>Assignee</th>
            <th>Due Dates</th>
            <th width="0" />
          </tr>
        </thead>

        <tbody>
          {playbook.tasksByStage[stage.key].map(task => (
            <Task canRequirePlaybookTasks={canRequirePlaybookTasks} key={task.name} playbook={playbook} task={task} />
          ))}
        </tbody>
      </table>

      <AddTask playbook={playbook} stage={stage} />
      {hasTasks && <CopyTask />}
    </div>
  );
}

const playbookPropTypes = PropTypes.shape({
  tasksByStage: PropTypes.object.isRequired,
}).isRequired;

PlaybookTasks.propTypes = {
  canRequirePlaybookTasks: PropTypes.bool,
  playbook: playbookPropTypes,
  playbooks: PropTypes.arrayOf(playbookPropTypes).isRequired,
  stage: PropTypes.shape({
    key: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  canRequirePlaybookTasks: state.canRequirePlaybookTasks
});

export default connect(mapStateToProps)(withDragDropContext(PlaybookTasks));
